import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pb-2" }
const _hoisted_2 = ["data-testid"]
const _hoisted_3 = ["disabled", "data-testid", "onClick"]
const _hoisted_4 = {
  key: 0,
  viewBox: "0 0 24 24",
  class: "h-5 w-5 shrink-0",
  "aria-hidden": "true"
}
const _hoisted_5 = ["d"]
const _hoisted_6 = { class: "min-w-0 flex-1" }
const _hoisted_7 = { class: "block text-sm font-semibold" }
const _hoisted_8 = {
  key: 0,
  class: "block text-xs font-normal text-gray-500"
}
const _hoisted_9 = ["data-testid"]

import { computed } from 'vue'
import BottomSheet from '@/components/designSystem/BottomSheet/BottomSheet.vue'
import type { ActionSheetItem } from './types'


export default /*#__PURE__*/_defineComponent({
  __name: 'ActionSheet',
  props: {
    modelValue: { type: Boolean },
    title: { default: undefined },
    items: {},
    testId: { default: 'action-sheet' }
  },
  emits: ["update:modelValue", "select"],
  setup(__props: any, { emit }) {

const props = __props;




/** Grupos na ordem dos itens: itens seguidos com a mesma `section` ficam juntos. */
const groups = computed(() =>
  props.items.reduce<{ name: string; items: ActionSheetItem[] }[]>((acc, item) => {
    const name = item.section ?? ''
    const last = acc[acc.length - 1]
    if (last && last.name === name) last.items.push(item)
    else acc.push({ name, items: [item] })
    return acc
  }, [])
)

const helpOf = (item: ActionSheetItem): string | undefined =>
  item.disabled && item.disabledReason ? item.disabledReason : item.description

function choose(item: ActionSheetItem): void {
  if (item.disabled) return
  // Fecha antes de emitir: a ação pode abrir outro overlay (modal de exportação, sheet de busca).
  emit('update:modelValue', false)
  emit('select', item.id)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BottomSheet, {
    "model-value": _ctx.modelValue,
    title: _ctx.title,
    "test-id": _ctx.testId,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (emit('update:modelValue', $event)))
  }, {
    footer: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        class: "h-11 w-full rounded-lg border border-solid border-gray-300 text-sm font-semibold text-gray-700",
        "data-testid": `${_ctx.testId}-dismiss`,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('update:modelValue', false)))
      }, " Fechar ", 8, _hoisted_9)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groups.value, (group) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: group.name || '_'
          }, [
            (group.name)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  class: "px-1 pb-1 pt-3 text-[11px] font-bold uppercase tracking-wide text-gray-500",
                  "data-testid": `${_ctx.testId}-section-${group.name}`
                }, _toDisplayString(group.name), 9, _hoisted_2))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.items, (item) => {
              return (_openBlock(), _createElementBlock("button", {
                key: item.id,
                type: "button",
                class: _normalizeClass(["flex min-h-[52px] w-full items-center gap-3 rounded-lg px-1 py-2 text-left disabled:cursor-not-allowed disabled:opacity-50", item.danger ? 'text-negative' : 'text-gray-800']),
                disabled: item.disabled,
                "data-testid": item.testId ?? `${_ctx.testId}-item-${item.id}`,
                onClick: ($event: any) => (choose(item))
              }, [
                (item.icon)
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_4, [
                      _createElementVNode("path", {
                        d: item.icon,
                        fill: "currentColor"
                      }, null, 8, _hoisted_5)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("span", _hoisted_6, [
                  _createElementVNode("span", _hoisted_7, _toDisplayString(item.label), 1),
                  (helpOf(item))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(helpOf(item)), 1))
                    : _createCommentVNode("", true)
                ])
              ], 10, _hoisted_3))
            }), 128))
          ], 64))
        }), 128))
      ])
    ]),
    _: 1
  }, 8, ["model-value", "title", "test-id"]))
}
}

})